export default "__VITE_ASSET__UQoVckbX__"